<template>
    <div>
        <h2>Let's get started on your class's tech ed journey!</h2>
        <br>
        <curriculum-search/>
    </div>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import CurriculumSearch from '@/components/CurriculumSearch.vue';

export default {
    components: {
        CurriculumSearch,
    },
};
</script>

<style scoped>

</style>
